export const WALKY_KEYS = {
  whatDoYouWantToAchive: "whatDoYouWantToAchive",
  achiveYourGoal: "achiveYourGoal",
  lastHappyWeight: "lastHappyWeight",
  sedentaryLifestyle: "sedentaryLifestyle",
  walkingSpendTime: "walkingSpendTime",
  workLifeLookLike: "workLifeLookLike",
  activityLevel: "activityLevel",
  targetBody: "targetBody",
  averageNight: "averageNight",
  energyLevels: "energyLevels",
  waterIntake: "waterIntake",
  hopeToAchieve: "hopeToAchieve",
};
